import { render, staticRenderFns } from "./Burn.vue?vue&type=template&id=51c7d99f&"
import script from "./Burn.vue?vue&type=script&lang=js&"
export * from "./Burn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports